import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MsgNotifier from '../MsgNotify/msgNotifier'
import Waves from 'node-waves'
import Radium from 'radium';

class App extends Component {
	componentDidMount = () => {
		Waves.init();
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
	};
  componentDidUpdate = () => {
    Waves.attach('.waves-btn', ['waves-button']);
    Waves.attach('.waves-icon', ['waves-circle']);
  };
  render() {
    return (
        <div style={{height: '100%'}}>
          <MsgNotifier />
          {this.props.children}
        </div>
    );
  }
}

App.propTypes = {
  children: PropTypes.object
};


export default Radium(App)


// WEBPACK FOOTER //
// ./src/App/MainClient/appContainer.jsx